import React, { useEffect, useRef, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import PieChart from "highcharts-react-official";
import { Box, Grid2, List, ListItem, ListItemIcon, ListItemText, Typography, useTheme, Skeleton, MenuItem, Select } from "@mui/material";
import { Circle } from "@mui/icons-material";
import { useGetInvoiceStatusQuery } from "store/slices/apis/paymentTrackerSlice";
import { FaSquareFull } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetInvoiceStatusByArgsQuery } from "store/slices/apis/paymentTrackerSlice";
import { useGetContractorQuery } from "store/slices/apis/contractors";
import { IoIosArrowDown } from "react-icons/io";

const StatusOfInvoice = () => {
    const theme = useTheme();
    const { projectId } = useParams();
    const [selectedCategory, setSelectedCategory] = useState(null)

    const { data, isLoading, error } = useGetInvoiceStatusQuery({
        projectId,
    })

    const { data: invoiceData } = useGetInvoiceStatusByArgsQuery(
        selectedCategory ? { projectId, vendor: selectedCategory } : skipToken
    );
    const { data: contractors } = useGetContractorQuery();


    const categories = contractors?.data?.map(item => item.name) || [];
    const mainData = selectedCategory ? invoiceData?.data || {} : data?.data || {};


    const moduleColorMap = {
        'Approved': '#E72B33',
        'Not Approved': '#295477',


    };


    const graphData = [
        {
            label: "Approved",
            count: Number((mainData?.approved ?? 0).toFixed(2))
        },
        {
            label: "Not Approved",
            count: Number((mainData?.notApproved ?? 0).toFixed(2))

        },

    ]

    const totalCount = graphData?.reduce((sum, item) => sum + item.count, 0) || 0;

    const openIssuesData = graphData?.map((item, index) => ({
        y: item.count,
        value: item.count,
        color: moduleColorMap[item.label],
        name: item.label,
        percentage: (item.count / totalCount) * 100,
    })) || [];

    const handleDrop = async (value) => {
        setSelectedCategory(value)

    }


    const options = {
        chart: {
            type: "pie",
            width: 180,
            height: 180,
            marginBottom: 10,
            marginTop: 10
        },
        title: {
            text: '',
            style: {
                fontWeight: 700,
                fontSize: '30px',
                color: '#000000',
                lineHeight: '40px'
            },
            align: 'center',
            verticalAlign: 'middle',
            y: 15,
        },
        subtitle: {
            useHTML: true,
            text: '',
            //text: '<div style="width: 26px; height: 26px; background-color: white; border-radius: 40%; padding-top: 3px;-moz-box-shadow: 1px 1px 4px #f3f3f3;-webkit-box-shadow: 1px 1px 4px #f3f3f3;box-shadow: 0 0 4px #f3f3f3;">58</div>',
            align: 'center',
            verticalAlign: 'middle',
            style: { "fontSize": "14px", "fontWeight": "400", "color": "#000000", "lineHeight": "100%", },
            y: 20, x: 0
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function () {
                // Customize the hover text here
                return `<b style='color: ${this.color}'>${this.name}</b>: ${this.y}`;
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: false,
                borderWidth: 0,
                borderRadius: 0,
                cursor: "pointer",
                innerSize: 130,
                dataLabels: {
                    enabled: false,
                },
                showInLegend: false,

                //startAngle: -20,
                // point: {
                //   events: {
                //     click: function () {
                //       setPopupData({
                //         name: this.severityname,
                //         value: this.y,
                //       });
                //       setOpen(true);
                //     }
                //   }
                // },
            }
        },
        series: [
            {
                name: "",
                color: "#006600",
                lineWidth: 1,
                dataLabels: {
                    enabled: false
                },
                marker: {
                    enabled: false,
                    symbol: "circle",
                    radius: 3,
                    states: {
                        hover: {
                            enabled: true,
                            lineWidth: 1
                        }
                    }
                },
                data: openIssuesData,
            }
        ]
    };



    if (isLoading) {
        return (
            <Box sx={{ p: 2, width: "100%", height: "251px", maxWidth: "100%", border: "1px solid #D8D8D8", mt: 0, borderRadius: "12px", overflow: "hidden", backgroundColor: "white" }}>
                <Box sx={{}}>
                    <Typography variant="body" sx={{ fontWeight: 500, fontSize: "18px", lineHeight: "100%", letterSpacing: '-0.4px', color: `${theme?.customSettings?.themeColor}`, }}>
                        Open Issues Distribution by Severity
                    </Typography>
                    {/* <Typography sx={{ mt: "5px", color: "#5052588A", fontWeight: 500, fontSize: "14px", lineHeight: "100%", letterSpacing: '-0.4px' }}>
                        Get a holistic view of how work is being prioritized
                    </Typography> */}
                </Box>
                <Grid2 container>
                    <Grid2 size={{ xs: 12, md: 7 }}>
                        {[...Array(3)].map((_, index) => (
                            <Grid2 container direction="row" spacing={1} key={index} sx={{ marginLeft: "10px", paddingTop: index === 0 ? '40px' : '10px' }}>
                                <Box sx={{ width: "25px", padding: "8px" }}>
                                    <Skeleton variant="circular" width={18} height={18} />
                                </Box>
                                <Box sx={{ width: "130px", padding: "8px" }}>
                                    <Skeleton variant="text" width={100} height={20} />
                                </Box>
                                <Box sx={{ width: "30px", padding: "4px" }}>
                                    <Skeleton variant="text" width={20} height={28} />
                                </Box>
                            </Grid2>
                        ))}
                    </Grid2>

                    <Grid2 size={{ xs: 12, md: 5 }} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Skeleton variant="circular" width={120} height={120} />
                    </Grid2>
                </Grid2>
            </Box>
        );
    }

    return (
        <Box sx={{
            p: 2,
            width: "100%",
            height: "100%",
            maxWidth: "100%",
            border: "1px solid #D8D8D8",
            borderRadius: "12px",
            overflow: "hidden",
            backgroundColor: "white",
            // display: 'flex',
            // flexDirection: 'column'
        }}>
            <Grid2 container >
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography
                        variant="body"
                        sx={{
                            fontWeight: 500,
                            fontSize: "17px",
                            lineHeight: "100%",
                            letterSpacing: "-0.4px",
                            color: `${theme?.customSettings?.themeColor}`,
                        }}
                    >
                        Status of Invoices
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }} sx={{ mt: { xs: 1.5, md: 0 } }}>
                    <Box sx={{ width: "100%", display: "flex", justifyContent: { xs: 'start', md: 'end' }, }}>
                        <Box sx={{ position: 'relative', width: { xs: '100%', sm: '250px', md: '210px' }, }}>
                            <Select
                                displayEmpty
                                value={selectedCategory || ""}
                                onChange={(e) => setSelectedCategory(e.target.value || null)}
                                IconComponent={IoIosArrowDown}
                                fullWidth
                                sx={{
                                    backgroundColor: '#E8E8E8',
                                    borderRadius: '4px',
                                    '& .MuiOutlinedInput-input': {
                                        padding: '4px 10px',
                                    },
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: 'none',
                                    }
                                }}
                            >

                                <MenuItem value="" disabled>
                                    Consultant/Contractor
                                </MenuItem>


                                {
                                    categories.map((item, index) => (
                                        <MenuItem key={index} value={item}>{item}</MenuItem>
                                    ))
                                }
                            </Select>


                            {selectedCategory && (
                                <Box
                                    onClick={() => setSelectedCategory(null)}
                                    sx={{
                                        position: 'absolute',
                                        right: '35px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                        fontSize: '18px',
                                        color: '#888',
                                        '&:hover': { color: '#000' },
                                        display: { xs: selectedCategory ? 'block' : 'none', md: 'block' },
                                    }}
                                >
                                    &#10005;
                                </Box>
                            )}
                        </Box>
                    </Box>



                </Grid2>
            </Grid2>

            <Box sx={{
                mt: "0px",
                flexGrow: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
                overflow: 'hidden',
                gap: 2,
                mt: 2
            }}>
                {openIssuesData?.length === 0 ? (
                    <Box sx={{ width: '100%', textAlign: 'center', py: 4 }}>
                        <Typography variant="body1" color="textSecondary">
                            No data available to display the chart.
                        </Typography>
                    </Box>
                ) : (
                    <>
                        <List sx={{
                            padding: 0,
                            mb: "12px",
                            mb: { xs: 1, md: "12px" },
                            flex: '1 1 auto',
                            overflow: 'auto',
                            maxHeight: '100%',
                            width: { xs: '100%', md: 'auto' },
                            textAlign: { xs: 'center', md: 'left' }
                        }}>
                            {openIssuesData?.map((val, index) => (
                                <ListItem key={index} sx={{ paddingLeft: 0, justifyContent: { xs: 'center', md: 'flex-start' }, alignItems: { xs: 'center', md: 'baseline' }, }}>
                                    <ListItemIcon sx={{ minWidth: '20px' }}>
                                        <FaSquareFull
                                            style={{ color: `${val?.color}`, height: '14px', width: '14px' }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={
                                            <>
                                                <Typography component="span" sx={{ fontWeight: 500, fontSize: "16px", letterSpacing: "-0.4px" }}>
                                                    {val?.name}:{' '}
                                                </Typography>
                                                <Typography component="span" sx={{ fontWeight: 500, fontSize: "16px", color: "#182A4E" }}>
                                                    {val?.value.toFixed(2)}
                                                </Typography>
                                            </>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>

                        <Box sx={{
                            flexShrink: 0,
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: { xs: '100%', md: 'auto' },
                            mt: { xs: 2, md: 0 }
                        }}>
                            <PieChart highcharts={Highcharts} options={options} />
                        </Box>
                    </>
                )}
            </Box>
        </Box>
    )

}

export default StatusOfInvoice;
